import React, { Suspense, useState } from "react";

import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component

import FullLoader from "components/loader/full-loader";
import { Dropdown } from "react-bootstrap";
import {  useFetchData } from "hooks/useApiHooks";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
import { useNavigate } from "react-router-dom";
import { buildQueryString } from "utils/queryHelpers";
import { LIMIT_DATA_PER_PAGE, URLS } from "utils/constants";
import { AgentProvider, useAgent } from "contexts/v1/masterData/AgentContext";
import { ProductProvider } from "contexts/v1/masterData/ProductContext";
import { deleteRequest } from "services/api";
import Swal from "sweetalert2";
import { LogAgentProvider } from "contexts/LogAgentContext";
import PermissionMiddleware from "middleware/PermissionMiddleware";

const AgentsPage = () => {
  const navigate = useNavigate();
  const { agents, refetch, Pagination } = useAgent();
  console.log(agents);
  const [search, setSearch] = useState("");
  const [currentPage] = useState(1);

  const queryString = buildQueryString({
    search: search || "",
    page: currentPage,
    limit: LIMIT_DATA_PER_PAGE,
  });

  useFetchData(`/agent${queryString}`, "agents");

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/agent/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Agent deleteing");
          refetch();
        }
      }
    });
  };

  const {
    handleSuccess,
    handleError,
    showCanvasHandler,
    handleSuccessToast,
  } = useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Agent",
      <AgentProvider>
        <ProductProvider>
          <CreatePage
            // onSuccess={handleSuccess}
            onSuccess={() => {
              // handleSuccess(true, "Agent created successfully");
              handleSuccessToast(true, "Agent createing");
              refetch();
            }}
            onError={handleError}
          />
        </ProductProvider>
      </AgentProvider>
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Agent",
      <AgentProvider>
        <ProductProvider>
          <CreatePage
            initialData={data}
            // onSuccess={handleSuccess}
            onSuccess={() => {
              // handleSuccess(true, "Agent updated successfully");
              handleSuccessToast(true, "Agent Updateing");
              // handleLoadingThenSuccessToast();

              refetch();
            }}
            onError={handleError}
          />
        </ProductProvider>
      </AgentProvider>
    );
  };

  const handleHistory = (e, data) => {
    e.preventDefault();
    navigate(URLS.v1.AGENT_HISTORY.replace(":id", data.id), { state: { agentName: data.name } });
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  if (agents.loading) return <FullLoader />;
  if (agents.error) return <Suspense error={agents.error} />;
  return (
    <LayoutDashboard>
      {/* Your content here */}
      <div className="container-fluid mt-5">
        <div className="table-container">
          <h1>AGENT</h1>
          <div className="search-container mb-3">
            {/* Search input */}
            <SearchInput handleSearch={handleSearch} defaultValue={search} />

            {/* Create button */}
            <button className="btn btn-primary" onClick={handleCreate}>
              Create
            </button>
          </div>

          {/* Table */}
          <div className="table table-responsive">
            <table className="table table-hover table-vcenter">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Agent Name</th>
                  {/* <th>Description</th> */}
                  <th>Product & Price</th>
                  {/* <th>Price</th> */}
                  <th>Color</th>
                  <th>Email</th>
                  <th>HP</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              {agents.data.length > 0 && (
                <tbody>
                  {agents.data.map((data, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.name}</td>
                        {/* <td>{data.description || "-"}</td> */}
                        {/* map products */}
                        <td>
                          {data.products &&
                            data.products.map((product, index) => (
                              <div key={index}>
                                {product.name} - Rp.
                                {parseInt(
                                  product.pivot.price_agent
                                ).toLocaleString()}
                              </div>
                            ))}
                        </td>
                        {/* <td>
                          {data.single && <span>Single</span>}
                          {data.single && data.tandem && <span> & </span>}
                          {data.tandem && <span>Tandem</span>}
                        </td>
                        <td>
                          {data.singlePrice && (
                            <div>
                              Single: Rp.{data.singlePrice.toLocaleString()}
                            </div>
                          )}
                          {data.tandemPrice && (
                            <div>
                              Tandem: Rp.{data.tandemPrice.toLocaleString()}
                            </div>
                          )}
                        </td> */}
                        <td>
                          <div
                            style={{
                              backgroundColor: data.color || "#fff",
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              border: "1px solid #ccc", // Tambahkan border agar warna putih terlihat
                            }}
                          ></div>
                        </td>
                        <td>{data.email || "-"}</td>
                        <td>{data.phone || "-"}</td>
                        <td className="text-end">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="default"
                              id="dropdownMenuButton1"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleUpdate(e, data)}
                              >
                                Edit
                              </Dropdown.Item>
                              {/* history */}
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleHistory(e, data)}
                              >
                                History
                              </Dropdown.Item>
                              <PermissionMiddleware allowedRoles={["superadmin"]}>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(data.id);
                                }}
                              >
                                Remove
                              </Dropdown.Item>
                              </PermissionMiddleware>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              )}
            </table>
          </div>

          {/* Pagination */}
          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default AgentsPage;

// Search Input Component
const SearchInput = () => {
  const { handleSearch, filterOptions } = useAgent();
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
